// extracted by mini-css-extract-plugin
export default {"textarea":"CreatePostTextarea_textarea__y+aJW"};